import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftIcon } from "../../assets/icon";
import { DoneIcon } from "../../assets/icon";

import {
  changeColorSection,
  changeShowParameterGroup,
} from "../../redux/actions/Settings";
import {
  getActiveColorInGroup,
  getListColorInGroup,
} from "../../redux/selectors";
import { ConfigColorItem } from "../ConfigColorItem/ConfigColorItem";

import { setConfiguration } from "../../utils/playcanvasChange";
import s from "./MobileConfig.module.scss";
import { useHistory } from "react-router";

export const MobileConfig = () => {
  let history = useHistory();
  const {
    Settings: {
      settings,
      showSettingGroupId,
      showSettingGroupInfo,
      showSettingGroupIndex,
    },
  } = useSelector((settings) => settings);
  const aciveColor = useSelector((state) => getActiveColorInGroup(state));
  const listColorInGroup = useSelector((state) => getListColorInGroup(state));

  const dispatch = useDispatch();

  useEffect(() => {
    if (!showSettingGroupId && settings.length > 0) {
      dispatch(changeShowParameterGroup(settings[0].id));
    }
    window.addEventListener("resize", updateSize);
  }, [dispatch, settings, showSettingGroupId]);

  function updateSize() {
    if (window.innerWidth < 993) {
      if (!showSettingGroupId && settings.length > 0) {
        dispatch(changeShowParameterGroup(settings[0].id));
      }
    }
  }

  // Guard: don't render anything until settings are populated
  if (!settings || settings.length === 0) {
    return <div style={{ color: '#fff', padding: 20 }}>Loading configuration...</div>;
  }

  const prewStep = () => {
    if (showSettingGroupIndex > 0) {
      const prevIndexSectionsGroup = showSettingGroupIndex - 1;
      dispatch(changeShowParameterGroup(settings[prevIndexSectionsGroup].id));
    } else {
      history.push("/");
    }
  };
  const nextStep = () => {
    if (showSettingGroupIndex < settings.length - 1) {
      const nextIndexSectionsGroup = showSettingGroupIndex + 1;
      dispatch(changeShowParameterGroup(settings[nextIndexSectionsGroup].id));
    }
  };

  const onChange = (section_id) => ({ id, name, assetId }) => {
    if (!window.configurator || !showSettingGroupInfo) return false;

    setConfiguration({
      propertyKey: showSettingGroupInfo.propertyKey,
      materialName: assetId || name,
    });

    dispatch(changeColorSection(section_id)(id));
  };

  let btnLeftClasses = `${s.control} ${s.control_left}`;
  // if (showSettingGroupIndex === 0) btnLeftClasses += ` ${s.control_disabled}`;

  let btnRightClasses = `${s.control} ${s.control_right}`;
  if (showSettingGroupIndex === settings.length - 1)
    btnRightClasses += ` ${s.control_finish}`;

  const renderColorItems = () => {
    return listColorInGroup.map((item) => {
      return (
        item["visible"] && (
          <ConfigColorItem
            key={item.id}
            activeId={aciveColor?.id}
            item={item}
            onChangeItem={onChange(showSettingGroupInfo.id, {
              id: item.id,
              name: item.name,
            })}
          />
        )
      );
    });
  };

  return (
    <div>
      <div className={`${s.configuration}`}>
        <div className={`${s.configuration_header}`}>
          <div className={btnLeftClasses} onClick={() => prewStep()}>
            <ArrowLeftIcon className={s.control_icon} />
          </div>
          <div className={`${s.configuration_header_main}`}>
            {showSettingGroupInfo?.name}: <span>{aciveColor?.name}</span>
          </div>
          <div className={btnRightClasses} onClick={() => nextStep()}>
            <>
              <ArrowLeftIcon className={s.control_icon} />
              <DoneIcon className={s.control_icon_done} />
            </>
          </div>
        </div>
        <div className={`${s.configuration_main}`}>
          <div className={`${s.configuration_main_wrap}`}>
            {showSettingGroupInfo && renderColorItems()}
          </div>
        </div>
      </div>
    </div>
  );
};
